export const TEST_ID = 'detailsViewEntityMenu';

export const MENU_DIRECTION = 'bottomRight';
